import { render, staticRenderFns } from "./CardCertificate.vue?vue&type=template&id=dd32ba32"
import script from "./CardCertificate.vue?vue&type=script&lang=js"
export * from "./CardCertificate.vue?vue&type=script&lang=js"
import style0 from "./CardCertificate.vue?vue&type=style&index=0&id=dd32ba32&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd32ba32')) {
      api.createRecord('dd32ba32', component.options)
    } else {
      api.reload('dd32ba32', component.options)
    }
    module.hot.accept("./CardCertificate.vue?vue&type=template&id=dd32ba32", function () {
      api.rerender('dd32ba32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardCertificate.vue"
export default component.exports